export interface Language {
  code: string;  // ISO 639-1 code
  name: string;  // Native name of the language
  nameEn: string; // English name (for search)
  flag: string;  // Flag emoji (representative country)
}

// Comprehensive list of world languages (ISO 639-1), sorted alphabetically by English name
export const WORLD_LANGUAGES: Language[] = [
  { code: 'af', name: 'Afrikaans', nameEn: 'Afrikaans', flag: '🇿🇦' },
  { code: 'sq', name: 'Shqip', nameEn: 'Albanian', flag: '🇦🇱' },
  { code: 'am', name: 'አማርኛ', nameEn: 'Amharic', flag: '🇪🇹' },
  { code: 'ar', name: 'العربية', nameEn: 'Arabic', flag: '🇸🇦' },
  { code: 'hy', name: 'Հայdelays', nameEn: 'Armenian', flag: '🇦🇲' },
  { code: 'az', name: 'Azərbaycan', nameEn: 'Azerbaijani', flag: '🇦🇿' },
  { code: 'eu', name: 'Euskara', nameEn: 'Basque', flag: '🇪🇸' },
  { code: 'be', name: 'Беларуская', nameEn: 'Belarusian', flag: '🇧🇾' },
  { code: 'bn', name: 'বাংলা', nameEn: 'Bengali', flag: '🇧🇩' },
  { code: 'bs', name: 'Bosanski', nameEn: 'Bosnian', flag: '🇧🇦' },
  { code: 'bg', name: 'Български', nameEn: 'Bulgarian', flag: '🇧🇬' },
  { code: 'my', name: 'မြန်မာစာ', nameEn: 'Burmese', flag: '🇲🇲' },
  { code: 'ca', name: 'Català', nameEn: 'Catalan', flag: '🇪🇸' },
  { code: 'zh', name: '中文', nameEn: 'Chinese', flag: '🇨🇳' },
  { code: 'hr', name: 'Hrvatski', nameEn: 'Croatian', flag: '🇭🇷' },
  { code: 'cs', name: 'Čeština', nameEn: 'Czech', flag: '🇨🇿' },
  { code: 'da', name: 'Dansk', nameEn: 'Danish', flag: '🇩🇰' },
  { code: 'nl', name: 'Nederlands', nameEn: 'Dutch', flag: '🇳🇱' },
  { code: 'en', name: 'English', nameEn: 'English', flag: '🇬🇧' },
  { code: 'et', name: 'Eesti', nameEn: 'Estonian', flag: '🇪🇪' },
  { code: 'fi', name: 'Suomi', nameEn: 'Finnish', flag: '🇫🇮' },
  { code: 'fr', name: 'Français', nameEn: 'French', flag: '🇫🇷' },
  { code: 'gl', name: 'Galego', nameEn: 'Galician', flag: '🇪🇸' },
  { code: 'ka', name: 'ქართული', nameEn: 'Georgian', flag: '🇬🇪' },
  { code: 'de', name: 'Deutsch', nameEn: 'German', flag: '🇩🇪' },
  { code: 'el', name: 'Ελληνικά', nameEn: 'Greek', flag: '🇬🇷' },
  { code: 'gu', name: 'ગુજરાતી', nameEn: 'Gujarati', flag: '🇮🇳' },
  { code: 'ht', name: 'Kreyòl ayisyen', nameEn: 'Haitian Creole', flag: '🇭🇹' },
  { code: 'ha', name: 'Hausa', nameEn: 'Hausa', flag: '🇳🇬' },
  { code: 'he', name: 'עברית', nameEn: 'Hebrew', flag: '🇮🇱' },
  { code: 'hi', name: 'हिन्दी', nameEn: 'Hindi', flag: '🇮🇳' },
  { code: 'hu', name: 'Magyar', nameEn: 'Hungarian', flag: '🇭🇺' },
  { code: 'is', name: 'Íslenska', nameEn: 'Icelandic', flag: '🇮🇸' },
  { code: 'ig', name: 'Igbo', nameEn: 'Igbo', flag: '🇳🇬' },
  { code: 'id', name: 'Bahasa Indonesia', nameEn: 'Indonesian', flag: '🇮🇩' },
  { code: 'ga', name: 'Gaeilge', nameEn: 'Irish', flag: '🇮🇪' },
  { code: 'it', name: 'Italiano', nameEn: 'Italian', flag: '🇮🇹' },
  { code: 'ja', name: '日本語', nameEn: 'Japanese', flag: '🇯🇵' },
  { code: 'jv', name: 'Basa Jawa', nameEn: 'Javanese', flag: '🇮🇩' },
  { code: 'kn', name: 'ಕನ್ನಡ', nameEn: 'Kannada', flag: '🇮🇳' },
  { code: 'kk', name: 'Қазақша', nameEn: 'Kazakh', flag: '🇰🇿' },
  { code: 'km', name: 'ភាសាខ្មែរ', nameEn: 'Khmer', flag: '🇰🇭' },
  { code: 'ko', name: '한국어', nameEn: 'Korean', flag: '🇰🇷' },
  { code: 'ku', name: 'Kurdî', nameEn: 'Kurdish', flag: '🇮🇶' },
  { code: 'ky', name: 'Кыргызча', nameEn: 'Kyrgyz', flag: '🇰🇬' },
  { code: 'lo', name: 'ລາວ', nameEn: 'Lao', flag: '🇱🇦' },
  { code: 'la', name: 'Latina', nameEn: 'Latin', flag: '🇻🇦' },
  { code: 'lv', name: 'Latviešu', nameEn: 'Latvian', flag: '🇱🇻' },
  { code: 'lt', name: 'Lietuvių', nameEn: 'Lithuanian', flag: '🇱🇹' },
  { code: 'lb', name: 'Lëtzebuergesch', nameEn: 'Luxembourgish', flag: '🇱🇺' },
  { code: 'mk', name: 'Македонски', nameEn: 'Macedonian', flag: '🇲🇰' },
  { code: 'mg', name: 'Malagasy', nameEn: 'Malagasy', flag: '🇲🇬' },
  { code: 'ms', name: 'Bahasa Melayu', nameEn: 'Malay', flag: '🇲🇾' },
  { code: 'ml', name: 'മലയാളം', nameEn: 'Malayalam', flag: '🇮🇳' },
  { code: 'mt', name: 'Malti', nameEn: 'Maltese', flag: '🇲🇹' },
  { code: 'mi', name: 'Te Reo Māori', nameEn: 'Maori', flag: '🇳🇿' },
  { code: 'mr', name: 'मराठी', nameEn: 'Marathi', flag: '🇮🇳' },
  { code: 'mn', name: 'Монгол', nameEn: 'Mongolian', flag: '🇲🇳' },
  { code: 'ne', name: 'नेपाली', nameEn: 'Nepali', flag: '🇳🇵' },
  { code: 'no', name: 'Norsk', nameEn: 'Norwegian', flag: '🇳🇴' },
  { code: 'ps', name: 'پښتو', nameEn: 'Pashto', flag: '🇦🇫' },
  { code: 'fa', name: 'فارسی', nameEn: 'Persian', flag: '🇮🇷' },
  { code: 'pl', name: 'Polski', nameEn: 'Polish', flag: '🇵🇱' },
  { code: 'pt', name: 'Português', nameEn: 'Portuguese', flag: '🇵🇹' },
  { code: 'pa', name: 'ਪੰਜਾਬੀ', nameEn: 'Punjabi', flag: '🇮🇳' },
  { code: 'ro', name: 'Română', nameEn: 'Romanian', flag: '🇷🇴' },
  { code: 'ru', name: 'Русский', nameEn: 'Russian', flag: '🇷🇺' },
  { code: 'sm', name: 'Gagana Samoa', nameEn: 'Samoan', flag: '🇼🇸' },
  { code: 'gd', name: 'Gàidhlig', nameEn: 'Scottish Gaelic', flag: '🏴󠁧󠁢󠁳󠁣󠁴󠁿' },
  { code: 'sr', name: 'Српски', nameEn: 'Serbian', flag: '🇷🇸' },
  { code: 'st', name: 'Sesotho', nameEn: 'Sesotho', flag: '🇱🇸' },
  { code: 'sn', name: 'ChiShona', nameEn: 'Shona', flag: '🇿🇼' },
  { code: 'sd', name: 'سنڌي', nameEn: 'Sindhi', flag: '🇵🇰' },
  { code: 'si', name: 'සිංහල', nameEn: 'Sinhala', flag: '🇱🇰' },
  { code: 'sk', name: 'Slovenčina', nameEn: 'Slovak', flag: '🇸🇰' },
  { code: 'sl', name: 'Slovenščina', nameEn: 'Slovenian', flag: '🇸🇮' },
  { code: 'so', name: 'Soomaali', nameEn: 'Somali', flag: '🇸🇴' },
  { code: 'es', name: 'Español', nameEn: 'Spanish', flag: '🇪🇸' },
  { code: 'su', name: 'Basa Sunda', nameEn: 'Sundanese', flag: '🇮🇩' },
  { code: 'sw', name: 'Kiswahili', nameEn: 'Swahili', flag: '🇰🇪' },
  { code: 'sv', name: 'Svenska', nameEn: 'Swedish', flag: '🇸🇪' },
  { code: 'tl', name: 'Tagalog', nameEn: 'Tagalog', flag: '🇵🇭' },
  { code: 'tg', name: 'Тоҷикӣ', nameEn: 'Tajik', flag: '🇹🇯' },
  { code: 'ta', name: 'தமிழ்', nameEn: 'Tamil', flag: '🇮🇳' },
  { code: 'tt', name: 'Татарча', nameEn: 'Tatar', flag: '🇷🇺' },
  { code: 'te', name: 'తెలుగు', nameEn: 'Telugu', flag: '🇮🇳' },
  { code: 'th', name: 'ไทย', nameEn: 'Thai', flag: '🇹🇭' },
  { code: 'ti', name: 'ትግርኛ', nameEn: 'Tigrinya', flag: '🇪🇷' },
  { code: 'tr', name: 'Türkçe', nameEn: 'Turkish', flag: '🇹🇷' },
  { code: 'tk', name: 'Türkmençe', nameEn: 'Turkmen', flag: '🇹🇲' },
  { code: 'uk', name: 'Українська', nameEn: 'Ukrainian', flag: '🇺🇦' },
  { code: 'ur', name: 'اردو', nameEn: 'Urdu', flag: '🇵🇰' },
  { code: 'ug', name: 'ئۇيغۇرچە', nameEn: 'Uyghur', flag: '🇨🇳' },
  { code: 'uz', name: 'Oʻzbekcha', nameEn: 'Uzbek', flag: '🇺🇿' },
  { code: 'vi', name: 'Tiếng Việt', nameEn: 'Vietnamese', flag: '🇻🇳' },
  { code: 'cy', name: 'Cymraeg', nameEn: 'Welsh', flag: '🏴󠁧󠁢󠁷󠁬󠁳󠁿' },
  { code: 'xh', name: 'isiXhosa', nameEn: 'Xhosa', flag: '🇿🇦' },
  { code: 'yi', name: 'ייִדיש', nameEn: 'Yiddish', flag: '🇮🇱' },
  { code: 'yo', name: 'Yorùbá', nameEn: 'Yoruba', flag: '🇳🇬' },
  { code: 'zu', name: 'isiZulu', nameEn: 'Zulu', flag: '🇿🇦' },
];

// Generate mapping from name to code dynamically
export const LANGUAGE_NAME_TO_CODE: Record<string, string> = Object.fromEntries(
  WORLD_LANGUAGES.map(lang => [lang.name, lang.code])
);

// Generate mapping from code to name dynamically
export const LANGUAGE_CODE_TO_NAME: Record<string, string> = Object.fromEntries(
  WORLD_LANGUAGES.map(lang => [lang.code, lang.name])
);

// Helper to get language by native name (for DB compatibility)
export function getLanguageByName(name: string): Language | undefined {
  return WORLD_LANGUAGES.find(lang => lang.name === name);
}

// Helper to get language by code
export function getLanguageByCode(code: string): Language | undefined {
  return WORLD_LANGUAGES.find(lang => lang.code === code);
}

// Convert to multiselect options format with flag icons
export function getLanguageOptions(): { value: string; label: string; icon: string }[] {
  return WORLD_LANGUAGES.map(lang => ({
    value: lang.name,  // Use name as value for DB compatibility
    icon: lang.flag,   // Flag emoji for visual recognition
    label: `${lang.name} (${lang.nameEn})`,
  }));
}
